document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },
        pagination: {
        el: ".swiper-pagination",
            renderBullet: function (index, className) {
                if (index === 0) {
                return ''
                    + '<span class="' + className + ' first-bullet"></span>'
                    + '<span class="custom-progress" aria-hidden="true">'
                    + '  <span class="custom-progress__bar"></span>'
                    + '</span>';
                }
                return '';
            }
        },
        autoplay: {
            delay: 11000,
            disableOnInteraction: false
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                const bar = s.pagination && s.pagination.el
                  ? s.pagination.el.querySelector('.custom-progress__bar')
                  : null;
                if (!bar) return;
                bar.style.width = ((1 - progress) * 100) + '%';
            },
            slideChange(s) {
                const bar = s.pagination && s.pagination.el
                  ? s.pagination.el.querySelector('.custom-progress__bar')
                  : null;
                if (bar) bar.style.width = '0%';
            }
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let filter = new Swiper(".swiper-filter", {
    speed: 1000,
    loop: true,
    slidesPerView: 3,
    navigation: {
        nextEl: ".sw-gal-next",
        prevEl: ".sw-gal-prev",
    }
    });

        (function syncFilterTabsWithContent(sw) {
        if (!sw || !sw.el) return;

        var rootEl = sw.el;

        function isCollection(v) {
            return v && (
            (typeof NodeList !== 'undefined' && v instanceof NodeList) ||
            (typeof HTMLCollection !== 'undefined' && v instanceof HTMLCollection)
            );
        }

        if (isCollection(rootEl)) rootEl = rootEl[0];
        if (typeof rootEl === 'string') rootEl = document.querySelector(rootEl);

        if (!rootEl || typeof rootEl.closest !== 'function') {
            if (sw.wrapperEl && sw.wrapperEl.parentElement) {
            rootEl = sw.wrapperEl.parentElement;
            } else {
            rootEl = document;
            }
        }

        var section = (rootEl !== document)
            ? (rootEl.closest('.background-tags') || document)
            : document;

        var tabs = Array.prototype.slice.call(
            section.querySelectorAll('.swiper-filter .swiper-slide:not(.swiper-slide-duplicate) .js-tab-tabs')
        );
        var items = Array.prototype.slice.call(section.querySelectorAll('.js-tab-item'));

        if (!tabs.length || !items.length) return;

        function clearActive() {
            tabs.forEach(function(t){ t.classList.remove('active'); });
            items.forEach(function(i){ i.classList.remove('active'); });
        }

        function activateByTag(tag) {
            clearActive();
            var t = section.querySelector('.js-tab-tabs[data-tag="' + tag + '"]');
            var it = section.querySelector('.js-tab-item[data-tag="' + tag + '"]');
            if (t) t.classList.add('active');
            if (it) it.classList.add('active');
        }

        function activateByIndex(idx) {
            var realIdx = (typeof sw.realIndex === 'number') ? sw.realIndex : idx;
            var tab = tabs[realIdx];
            if (!tab) return;
            activateByTag(tab.getAttribute('data-tag'));
        }

        activateByIndex((typeof sw.realIndex === 'number') ? sw.realIndex : 0);

        if (sw.on && typeof sw.on === 'function') {
            sw.on('slideChange', function () {
            activateByIndex((typeof sw.realIndex === 'number') ? sw.realIndex : 0);
            });
        }

        tabs.forEach(function(tab, idx) {
            tab.addEventListener('click', function() {
            if (typeof sw.slideToLoop === 'function') {
                sw.slideToLoop(idx, 300);
            } else if (typeof sw.slideTo === 'function') {
                sw.slideTo(idx, 300);
            }
            activateByIndex(idx);
            });
        });

        })(filter);


    // Slider Swiper 

    let slidertext = new Swiper('.single-quad-slider__text', {
        loop: true,
        speed: 800,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.sw-gal-next',
            prevEl: '.sw-gal-prev'
        },
        pagination: {
            el: ".swiper-pagination-slider",
            renderBullet: function (index, className) {
            if (index === 0) {
                return `
                    <span class="${className} first-bullet"></span>
                    <span class="custom-progress" aria-hidden="true">
                      <span class="custom-progress__bar"></span>
                    </span>
                `;
            }
                return `<span class="${className}"></span>`;
            }
        },
        autoplay: {
            delay: 12000,
            disableOnInteraction: false
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                const bar = s.pagination && s.pagination.el
                  ? s.pagination.el.querySelector('.custom-progress__bar')
                  : null;
                if (!bar) return;
                bar.style.width = ((1 - progress) * 100) + '%';
            },
            slideChange(s) {
                const bar = s.pagination && s.pagination.el
                  ? s.pagination.el.querySelector('.custom-progress__bar')
                  : null;
                if (bar) bar.style.width = '0%';
            }
        }
    });

    const images = document.querySelectorAll('.single-quad-slider__image .image');

    function updateImageClasses() {
        let activeIndex = slidertext.realIndex; 
        let total = images.length;

        images.forEach((img, i) => {
            img.classList.remove('first', 'back', 'fade');

            void img.offsetWidth;

            if (i === activeIndex) {
                img.classList.add('first', 'fade');
            } else if (i === (activeIndex + 1) % total) {
                img.classList.add('back', 'fade');
            }
        });
    }

    slidertext.on('slideChange', updateImageClasses);
    updateImageClasses();


    // Gallery Home Slider
    
    var Gallery = new Swiper('.gallery-quad__slider', {
        loop: true,
        speed: 1000,
        spaceBetween: 35,

        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev"
        },

        pagination: {
            el: ".gallery-swiper-pagination",
            type: "bullets",
            clickable: false,
            renderBullet: function (index, className) {
            var html = '';
            if (index === 0) {
                return `
                    <span class="${className} first-bullet"></span>
                    <span class="custom-progress" aria-hidden="true">
                      <span class="custom-progress__bar"></span>
                    </span>
                `;
            }
                return `<span class="${className}"></span>`;
            }
        },

        autoplay: { 
            delay: 10000, 
            disableOnInteraction: false 
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                const bar = s.pagination && s.pagination.el
                  ? s.pagination.el.querySelector('.custom-progress__bar')
                  : null;
                if (!bar) return;
                bar.style.width = ((1 - progress) * 100) + '%';
            },
            slideChange(s) {
                const bar = s.pagination && s.pagination.el
                  ? s.pagination.el.querySelector('.custom-progress__bar')
                  : null;
                if (bar) bar.style.width = '0%';
            }
        },
        breakpoints: {
            900:  { slidesPerView: 1 },
            1024: { slidesPerView: "auto" }
        }
    });

    let sliderReviews = new Swiper('.swiper-slider-reviews', {
        loop: true,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            renderBullet: function (index, className) {
            if (index === 0) {
                return `
                    <span class="${className} first-bullet"></span>
                    <span class="custom-progress" aria-hidden="true">
                      <span class="custom-progress__bar"></span>
                    </span>
                `;
            }
                return `<span class="${className}"></span>`;
            }
        },

        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                const bar = s.pagination && s.pagination.el
                  ? s.pagination.el.querySelector('.custom-progress__bar')
                  : null;
                if (!bar) return;
                bar.style.width = ((1 - progress) * 100) + '%';
            },
            slideChange(s) {
                const bar = s.pagination && s.pagination.el
                  ? s.pagination.el.querySelector('.custom-progress__bar')
                  : null;
                if (bar) bar.style.width = '0%';
            }
        }
    });

      let locationTap = document.querySelectorAll('.location-block');
    let locationSlide = document.querySelectorAll('.location-slider');

    if(locationSlide){

        const locationSlider = new Swiper('.location-slider', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            }
        });
        locationTap.forEach(function(hB,hBc) {
            let hNav = hB.querySelectorAll('.location-point');
            let textG = hB.querySelector('.copy-generic');
            let textS = hB.querySelector('.location-slider');
            hNav.forEach(function(h_nav) {
                let navCount = h_nav.dataset.nav;
                h_nav.addEventListener('click', function(e){
                    e.preventDefault();
                    if(locationTap.length > 1){
                        locationSlider[hBc].slideTo(navCount, 500);
                    } else {
                        locationSlider.slideTo(navCount, 500);
                    }
                    hNav.forEach(function(h_nav) {
                        h_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                    if(!textG.classList.contains('close')){
                        textG.classList.add('close');
                        textS.classList.add('open');
                    }
                });
                if(locationTap.length > 1){
                    locationSlider[hBc].on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(locationSlider[hBc].realIndex == navC){
                                h_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    let navIn = 0;
                    locationSlider.on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(locationSlider.realIndex == navC && navIn != 0){
                                h_nav.classList.add('active');
                            }
                            navIn++;
                        });
                    });
                }
            });
        });
    }

});
